import searchPlacesConfig from './search-places-facets.config';

export default {
  title: 'search#places_title',
  searchId: 'place',
  searchConfig: searchPlacesConfig,
  resourcePath: '/places',
  facetsTitle: 'search#facets_title',
  totalResultsText: 'search#places_total',
  filtersTitle: 'search#filters_title',
  grid: 3,
  description: {
    id: 'place',
    buttonText: 'search#description_button',
    linkText: 'search#description_link',
  },
  sort: {
    label: 'search#sort_title',
    options: [
      // {
      //   value: '_score',
      //   label: 'search#sort_score',
      //   selected: false,
      //   disabled: true
      // },
      {
        value: 'slug.keyword_ASC',
        label: 'search#sort_asc',
        selected: true
      },
      {
        value: 'slug.keyword_DESC',
        label: 'search#sort_desc',
        selected: false
      }
    ]
  },
  pagination: {
    limit: 5,
    options: [
      12,
      24,
      48
    ]
  },
  itemPreview: {
    classes: 'is-vertical'
  },
  fallback: {
    text: 'search#fallback_text',
    button: 'search#fallback_button'
  },
  ko: {
    text: 'search#ko_text',
    button: 'search#ko_button'
  }
};
